module.exports = __webpack_public_path__ + "static/media/slash-eye-blue.83bbd9d2.svg";